export default {
  setSubscriptionPlans: (state, payload) => {
    state.subscriptionPlans = payload;
  },
}
